import Component from '@Component';

const DEFAULTS = {
  openClass: 'visible',
};

export default class AdventureVanMenu extends Component {
  static selector = '[data-comp-van-menu]';

  #state = {
    visible: false,
  }

  constructor(element) {
    super(element);
    this.init();
    this.events();
    this.$container.component = this;
  }

  init() {
    this.trigger = this.$container.querySelector('[data-comp-van-menu-trigger]');
    this.menu = this.$container.querySelector('[data-comp-van-menu-menu]');
  }

  events() {
    this.boundClickOutside = e => this.handleClickOutside(e);
    this.boundRemoveCloseClass = () => this.removeCloseClass();

    this.trigger.addEventListener('click', () => {
      if (this.#state.visible === true) {
        this.hideMenu();
      } else {
        this.showMenu();
      }
    });

    window.addEventListener('resize', () => {
      this.hideMenu();
    });
  }

  showMenu() {
    document.addEventListener('click', this.boundClickOutside);
    this.$container.classList.add(DEFAULTS.openClass);
    // this.menu.dataset.aniState = 'running';
    this.#state.visible = true;
    this.toggleBodyStyle();
  }

  hideMenu() {
    document.removeEventListener('click', this.boundClickOutside);
    this.$container.classList.remove(DEFAULTS.openClass);
    // this.menu.addEventListener('animationend', this.boundRemoveCloseClass);
    // this.menu.dataset.aniState = 'running:out';
    this.#state.visible = false;

    if (window.innerWidth > 768) {
      this.toggleBodyStyle();
    }
  }

  removeCloseClass() {
    this.$container.classList.remove(DEFAULTS.openClass);
    this.menu.removeEventListener('animationend', this.boundRemoveCloseClass);
  }

  handleClickOutside(e) {
    if (this.#state.visible && !e.target.closest('[data-comp-van-menu]') && e.target !== this.trigger) {
      this.hideMenu();
    }
  }

  toggleBodyStyle() {
    if (this.#state.visible === true) {
      Object.assign(document.body.style, {
        overflow: 'hidden',
        position: 'fixed',
        height: '100%',
        width: '100%',
      });
    } else {
      Object.assign(document.body.style, {
        overflow: null,
        position: null,
        height: null,
        width: null,
      });
    }
  }
}
